<div class="sd-form iam">
  <div class="sd-form__head">
    <div class="sd-form__head-text iam__head">
      <img class="iam__provider" [src]="providerIcon" alt="" aria-hidden="true">
      <div>
        <h3 class="sd-form__title">{{ options?.justConnected ? provider + ' connected' : 'Inbox Automator' }}</h3>
        <p class="sd-form__subtitle">{{ email }}</p>
      </div>
    </div>
    <button type="button" class="sd-icon-btn" aria-label="Close" (click)="close()">
      <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
        <path d="M4 4l8 8M12 4l-8 8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
      </svg>
    </button>
  </div>

  <div class="sd-form__body">
    <!-- What every plan gets, and is already happening. -->
    <div class="iam-step is-done">
      <span class="iam-step__icon" aria-hidden="true">
        <svg viewBox="0 0 16 16" fill="none">
          <path d="M3.5 8.5l3 3 6-7" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </span>
      <div class="iam-step__text">
        <span class="iam-step__title">Email sync is on</span>
        <span class="iam-step__desc">New mail from this inbox shows up in Emails, ready for you to review.</span>
      </div>
    </div>

    <!-- The paid step beyond it. -->
    <div class="iam-card" [class.is-active]="mode === 'active'" [class.is-locked]="mode === 'upgrade' || mode === 'ask-admin'">
      <div class="iam-card__head">
        <span class="iam-card__icon" aria-hidden="true">
          <svg viewBox="0 0 20 20" fill="none">
            <path d="M11 2L4 11.5h5L8 18l7-9.5h-5L11 2z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" />
          </svg>
        </span>
        <div class="iam-card__title-wrap">
          <span class="iam-card__title">Inbox Automator</span>
          <span class="iam-badge iam-badge--active" *ngIf="mode === 'active'">
            <span class="iam-dot"></span> Active
          </span>
          <span class="iam-badge" *ngIf="mode === 'upgrade'">
            <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
              <rect x="3.5" y="7" width="9" height="6.5" rx="1.5" stroke="currentColor" stroke-width="1.4" />
              <path d="M5.5 7V5a2.5 2.5 0 015 0v2" stroke="currentColor" stroke-width="1.4" />
            </svg>
            Paid plans
          </span>
        </div>
      </div>

      <ng-container *ngIf="mode !== 'active'">
        <p class="iam-card__lead">Let Synced work this inbox for you, not just sync it.</p>
        <ul class="iam-list">
          <li>Reads every new email and its attachments as they arrive</li>
          <li>Files bills, receipts and statements into Synced automatically</li>
          <li>Actions what it can, so only the exceptions need you</li>
        </ul>
      </ng-container>

      <ng-container *ngIf="mode === 'active'">
        <p class="iam-card__lead" *ngIf="result === 'activated'">
          You’re all set. New mail to {{ email }} will be picked up by Inbox Automator.
        </p>
        <p class="iam-card__lead" *ngIf="result !== 'activated'">
          Switched on{{ mailbox?.activatedUtc ? ' ' + (mailbox.activatedUtc | date:'d MMM y') : '' }}. New mail to this inbox is picked up automatically.
        </p>
        <p class="iam-card__hint">
          See what it does in <a routerLink="/automate" (click)="close()">Flows</a>.
        </p>
      </ng-container>

      <p class="iam-card__hint" *ngIf="mode === 'activate' && justUpgraded">
        Your new plan includes Inbox Automator. Switch it on for this inbox below.
      </p>
      <p class="iam-card__hint" *ngIf="mode === 'ask-admin'">
        Your plan includes Inbox Automator. Ask an admin of this organisation to switch it on for this inbox.
      </p>
      <p class="iam-card__hint" *ngIf="mode === 'upgrade'">
        Available on paid plans. Upgrade to switch it on for this inbox.
      </p>
    </div>

    <p class="sd-form__error" *ngIf="errorMessage">{{ errorMessage }}</p>
  </div>

  <div class="sd-form__footer">
    <ng-container [ngSwitch]="loading ? 'loading' : mode">
      <ng-container *ngSwitchCase="'loading'">
        <button type="button" class="sd-btn sd-btn--secondary" (click)="close()">Close</button>
        <button type="button" class="sd-btn sd-btn--primary" disabled>Loading…</button>
      </ng-container>
      <ng-container *ngSwitchCase="'activate'">
        <button type="button" class="sd-btn sd-btn--secondary" (click)="close()">Not now</button>
        <button type="button" class="sd-btn sd-btn--primary" (click)="activate()" [disabled]="busy">
          {{ busy ? 'Activating…' : 'Activate Inbox Automator' }}
        </button>
      </ng-container>
      <ng-container *ngSwitchCase="'upgrade'">
        <button type="button" class="sd-btn sd-btn--secondary" (click)="close()">Not now</button>
        <button type="button" class="sd-btn sd-btn--primary" (click)="upgrade()">Upgrade to activate</button>
      </ng-container>
      <ng-container *ngSwitchCase="'active'">
        <button type="button" class="sd-btn sd-btn--secondary" (click)="deactivate()" [disabled]="busy"
                *ngIf="result !== 'activated'">
          {{ busy ? 'Turning off…' : 'Turn off' }}
        </button>
        <button type="button" class="sd-btn sd-btn--primary" (click)="close()">Done</button>
      </ng-container>
      <ng-container *ngSwitchDefault>
        <button type="button" class="sd-btn sd-btn--primary" (click)="close()">Done</button>
      </ng-container>
    </ng-container>
  </div>
</div>
